export function handleButtonKeyPress(fn) {
  return function handleKeyPress(event, ...args) {
    if (event.keyCode === 13 || event.keyCode === 32) {
      fn(event, ...args);
    }
  };
}

